import { inject, injectable } from 'inversify'
import * as Api from '@xlearn/common';
import { PlayerModule } from '../api'
import { NotificationService, createNotification } from '@xlearn/async-toolbox'
import { NotificationServiceSymbol } from './service'
import { BadgeEarnedNotification } from '../badge/notification';
import { TemporaryTrackingErrorNotification } from '../tracking/notification';

@injectable()
export class NotificationPlayerModule implements PlayerModule {

  readonly name = 'notification'
  
  constructor(
    @inject(NotificationServiceSymbol)
    private notificationService: NotificationService) {}

  init() {
    this.notificationService.start()
    
    // this.notificationService.show(createNotification<BadgeEarnedNotification>(
    //   'badge-earned',
    //   {
    //     badge: {
    //       name: 'Badge name',
    //       description: 'Badge description',
    //       imageUri: 'image'
    //     }
    //   }
    // ))
  }

  start(): void {

  }

  reset(): void {
  }

  async stop() {
    this.notificationService.finish()
  }
}
